import { StyleSheet } from 'react-native';
import config from '../../lib/config';

export default StyleSheet.create({
  viewMoreArrow: {
    borderWidth: 1,
    borderColor: config.theme.advert.headingTextColor,
    borderRadius: 25,
    padding: 12,
    marginBottom: 16,
    width: 50,
    height: 50,
    justifyContent: 'center',
  },
  viewMoreArrowDisabled: {
    borderColor: '#dddddd',
  },
  submitArea: {
    justifyContent: 'center',
    marginTop: 26,
    alignContent: 'center',
    alignItems: 'center',
  },
});
